import '../styles/main.scss';

import { graphql } from 'gatsby';
import React from 'react';

import groq from 'groq';
import { useTranslation } from 'react-i18next';
import { Module } from '../components/ModulesContent';
import { HeroType } from '../components/ui/Hero';
import { ALL_LANGS } from '../constants';
import { LandingPageContext } from '../contexts/LandingPageContext';
import { LocalizedSEO } from '../graphql-fragments/seo';
import { withPagePreview } from '../preview/previewUtils';
import { withI18n } from '../utils/hocs';
import { localize } from '../utils/sanity';
import PageTemplate from './PageTemplate';

export const query = graphql`
  query GetLandingPageById($id: String!) {
    sanityLandingPage(_id: { eq: $id }) {
      title {
        ...LocaleStringFragment
      }
      slug {
        current
      }
      hero {
        ...Hero
      }
      modules {
        ...Modules
      }
      hideFormModule
      seo {
        ...SEO
      }
    }
    sanityWebsite {
      contacts {
        calendlyLink
      }
    }
  }
`;

const groqQuery = groq`{
  "sanityLandingPage": *[_id == $id][0] {
     ...
  }
}`;

export type BackgroundColorTheme = '#E5F8E8' | '#EFECFA';

interface LocalizedQueryData {
  sanityLandingPage: {
    title: string;
    slug: {
      current: string;
    };
    hero: HeroType;
    modules?: Array<Module>;
    hideFormModule?: boolean;
    seo?: LocalizedSEO;
  };
  sanityWebsite: {
    contacts: {
      calendlyLink: string;
    };
  };
}

const LandingPage = withPagePreview<LocalizedQueryData>(
  {
    groqQuery,
  },
  ({ data }): React.ReactElement => {
    const { i18n, t } = useTranslation();

    const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
    const localizedData: LocalizedQueryData = localize(data, langs);

    return (
      <LandingPageContext.Provider value={true}>
        <PageTemplate page={localizedData.sanityLandingPage} hideNavigation />
      </LandingPageContext.Provider>
    );
  },
);

export default withI18n(LandingPage);
